export default function XSD_ElementsOnly() {
  return (
    <div>
      <h1>XSD_ElementsOnly</h1>
      <p>This is the XSD_ElementsOnly component.</p>
    </div>
  );
}